import { bulk as bulkUpdate } from './update';
import { subscribe } from './subscription';

export function request(id, query) {
    return {
        type: 'PARTICIPANTS_QUERY_REQUEST',
        query,
        id
    };
}

export function error(id, errors) {
    return {
        type: 'PARTICIPANTS_QUERY_ERROR',
        errors,
        id
    };
}

export function finish(id, participants) {
    return (dispatch) => {
        dispatch(bulkUpdate(participants));

        dispatch({
            type: 'PARTICIPANTS_QUERY_FINISH',
            participants,
            id
        });

        dispatch(subscribe(participants.map((participant) => participant.id)));
    };
}
